var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header-card",
      class: { "night-mode": _vm.currentGreetingKey === "night01" },
      style: { backgroundImage: "url(" + _vm.currentBgImage + ")" },
    },
    [
      _c("div", { staticClass: "left-content" }, [
        _vm.timeIcon
          ? _c("div", { staticClass: "time-icon" }, [
              _vm._v(_vm._s(_vm.timeIcon)),
            ])
          : _vm._e(),
        _c("div", { staticClass: "greeting-wrap" }, [
          _c("h2", { staticClass: "greeting-title" }, [
            _vm._v(_vm._s(_vm.greetingTitle)),
          ]),
          _c("p", { staticClass: "greeting-subtitle" }, [
            _vm._v(_vm._s(_vm.greetingSubtitle)),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }